import { t } from "i18next";
import NotFoundComponent from "../components/NewDesign/NotFound/NotFoundComponent";
import Page from "../components/Page";

const Unauthorized = () => {
    return (
      <Page>
    
      <NotFoundComponent
                width={400}
                height={419}
                showBtn={false}
                showMsg={true}
                msgLine={t("This content is not available in your current subscription, please contact to Halifax Sales AI support team.")}
              />
      
    </Page>)
  };
  
  export default Unauthorized;